// @flow
import React, { useEffect, useState, memo } from "react";
import { isAndroid } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logOutRequest } from "../../../pages/Account/redux/actions";
import { openMenu } from "../../../pages/Home/redux/actions";
import { ReactComponent as HeaderLogo} from "../../../assets/images/header_logo.svg";
import { ReactComponent as HeaderQR} from "../../../assets/images/header_qr.svg";
import { ReactComponent as HeaderNavToogle} from "../../../assets/images/header_nav_toggle.svg";

type Props = {
  logOutRequest: Function,
  isLoading: Boolean,
  leftChild: any,
  rightChild: any,
  handleLeftClick: Function,
  handleRightClick: Function,
  menuShow: Boolean,
  leftChildShow: Boolean,
  openMenu: Function,
  // handleOpenQRCode: Function
};

const HeaderHs1 = ({
  isLoading,
  handleLeftClick,
  handleRightClick,
  leftChild,
  rightChild,
  menuShow,
  leftChildShow,
  // handleOpenQRCode
}: Props) => {
  const { userInfo } = useSelector((state) => state.authReducers);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  const location = useLocation();
  // console.log(location.pathname,ROUTERS.LOGIN, 'location');

  useEffect(() => {});
  // const logOut = () => {
  //   dispatch(logOutRequest());
  //   navigate(ROUTERS.LOGIN);
  // }

  // const renderBtnAccout = () => {
  //   if (userInfo.id) {
  //     return  (<div className="header__left" onClick={() => logOut()}>
  //               LogOut
  //             </div>)
  //   }else{
  //     return  (<div className="header__left" onClick={() => navigate(ROUTERS.LOGIN)}>
  //               LogIn
  //             </div>)
  //   }
  // }

  const handleOpenMenu = () => {
    // document.getElementsByClassName("bm-overlay")[0].click();
    dispatch(openMenu(true));
    if (isAndroid) {
      window.nativeRightMenu(true);
    }
  };

  const handleOpenQRCode = () => {
    console.log('handleOpenQRCode');
    window.nativeOpenQRScan();
  }

  window.callCloseRightMenu = function() {
    console.log('callCloseRightMenu');
    dispatch(openMenu(false));
  }

  return (
    // <div className="header">
    //     {
    //       leftChildShow ? (<div className="header__left" onClick={() => handleLeftClick()}>
    //                         {leftChild}
    //                       </div>)
    //                     : (<div className="header__left" >
    //                       </div>)

    //     }

    //     <div className="header__center" >Center </div>

    //     {
    //       !menuShow ?  <div className="header__right" onClick={() => handleRightClick()}>{rightChild}</div> :  <div className="header__right"> </div>
    //     }

    // </div>

    <header className="header__hs1 fixed-top">
      <div className="left">
        <a title="#" href="#" className="header__hs1_logo">
          {/* <img
            className="header__hs1_logo"
            src={HeaderLogo}
          /> */}
          <HeaderLogo />
        </a>
      </div>
      <div className="right">
        <a title="#" className="header__hs1_qr" onClick={() => handleOpenQRCode()}>
            <HeaderQR/>
        </a>
        <a title="#" href="#" className="header__hs1_nav_toggle" onClick={() => handleOpenMenu()}>
          <HeaderNavToogle />
        </a>
        {/* {
             !menuShow ?  <div className="header__hs1_nav_toggle" onClick={() => handleRightClick()}>{rightChild}</div> :  <div className="header__hs1_nav_toggle"> </div>
          } */}
      </div>
    </header>
  );
};

HeaderHs1.defaultProps = {
  leftChild: "left",
  leftChildShow: true,
};

export default memo(HeaderHs1);
